import React from 'react';

// THE LINE UNDER EACH COLUMN of the /mcc priced view: how big the die-cut output comes out, and nothing at all
// under the printing column.
//
// Frank's own, forked from components/layout_and_quote_builder/quote_builder/SolutionDimensions.jsx -- which the
// frozen legacy page keeps rendering unchanged -- because everything ELSE that panel said, the priced view
// already says somewhere the reader is looking:
//   * the (x by y) copy count -- the copies are drawn in the picture directly above, laid out on the sheet;
//   * the efficiency percentage -- the solution card above the table carries it as its top-right badge;
//   * "Show dimensions" -- a popup of layout annotations and dieline options, which /mcc gives a whole tab.
// Repeating them under the picture was three answers to questions the page had already answered. What is left is
// the one number none of those show: the finished output size.
//
// Dropping the popup also drops the last thing the /mcc priced view asked of the LEGACY page -- its
// /manufacturing-cost-calculator/.../presented_layout_dimensions endpoint, which that button was the only caller
// of from here.
const FrankSolutionDimensions = ({ type, solution }) => {
  // The printing pass has nothing left to say: its size is the sheet named above the picture.
  if (type !== 'diecutting') { return null; }

  const outputDimensions = solution && solution.diecutting_result
    && solution.diecutting_result.calculated_output_dimensions;
  if (!outputDimensions) { return null; }

  // The reader's own unit -- millimetres to two decimals, inches to four. The same precision the panel this was
  // forked from used, so the number does not change as sections move onto Frank.
  const presentedLength = (valueInMillimetres) => {
    if (window.user_unit === 'in' || window.user_unit === 'infr') {
      return `${(parseFloat(valueInMillimetres) / 25.4).toFixed(4)} in`;
    }
    return `${parseFloat(valueInMillimetres).toFixed(2)} mm`;
  };

  // Two halves, where the two-cell table this replaced sat. A plain row, NOT that table: a bootstrap `.table`
  // gives every cell its own `border-top`, which drew a second rule a few pixels under the priced table's own
  // row divider -- two lines above one number, one of them belonging to a table that existed only to put the
  // pair side by side.
  return (
    <div style={{ display: 'flex' }} data-solution-dimensions={type}>
      <span style={{ flex: 1 }}>
        <span className="arrow"><i className="fa fa-arrows-h" aria-hidden="true"></i></span>
        <span className="info-quote" data-output-x-length> {presentedLength(outputDimensions.output_x_length)} </span>
      </span>
      {/* The up-and-down measure sits at the RIGHT edge, not halfway. The two are the width and the height of one
          output, so reading them as a pair is the point -- pushed apart they bracket the column, and the eye can
          take both without hunting for where the second one starts. */}
      <span style={{ flex: 1, textAlign: 'right' }}>
        <span className="arrow"><i className="fa fa-arrows-v" aria-hidden="true"></i></span>
        <span className="info-quote" data-output-y-length> {presentedLength(outputDimensions.output_y_length)} </span>
      </span>
    </div>
  );
};

export default FrankSolutionDimensions;
